import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TimelineActions } from "../../_actions";
import { TimelineListItem } from "../_components";
import { useModal } from "../../_contexts";
import { Button, Icon } from "../../_components";
import { useEventListener } from "../../_hooks";
import ReactTooltip from "react-tooltip";

const deleteText =
  "Deleting a Timeline will also delete ALL EVENTS! Please be absolutely sure you want to do this before proceeding. This cannot be undone. Any deleted data WILL be gone FOREVER!\r\nIf you proceed, and later want to have these Events, you'll need to re-create them!";

export function TimelineListForm() {
  const { items } = useSelector((state) => state.timelines);
  const [filteredTimelines, setFilteredTimelines] = useState([]);
  const [timelines, setTimelines] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const { openModal, closeModal } = useModal();

  const dispatch = useDispatch();

  const timelinesUsed = items ? items.length : 0;
  const timelinesAvailable =
    parseInt(process.env.CHRONOS_TIMELINES_DISPLAY, 10) - timelinesUsed;

  const handleNewTimeline = () => {
    // console.log('Create New Timeline!!');
    openModal("newTimeline", { prevModal: "timelineManager" });
  };

  const handleDeleteTimeline = (id) => {
    // console.log('Deleting Timeline!');
    const selectedTimeline = filteredTimelines.find((t) => t._id === id);
    openModal("confirmDelete", {
      type: "timeline",
      item: { ...selectedTimeline },
      prevModal: "timelineManager",
      text: deleteText,
    });
  };

  const handleTimelineToggle = (id) => {
    const selectedTimeline = filteredTimelines.find((t) => t._id === id);
    // console.log(id, selectedTimeline);
    const timeline = { ...selectedTimeline };
    // console.log(timeline);
    const newState = !timeline.active;
    timeline.active = newState;
    // console.log('Toggling Timeline!', timeline);
    //Run dispatch

    dispatch(TimelineActions.updateTimeline(timeline));
  };

  const handleEditTimeline = (id) => {
    // console.log('Editing Timeline!');
    const selectedTimeline = filteredTimelines.find((t) => t._id === id);
    openModal("newTimeline", {
      item: { ...selectedTimeline },
      prevModal: "timelineManager",
    });
  };

  const handleSearchChange = (ev) => {
    const { value } = ev.target;
    setSearchVal(value);
  };

  // const handleFormClose = (ev) => {
  //   closeModal();
  // };

  useEffect(() => {
    if (searchVal && searchVal.length > 0) {
      //filter them
      const results = filteredTimelines
        .filter((timeline) => {
          if (
            timeline.title.toLowerCase().indexOf(searchVal.toLowerCase()) > -1
          ) {
            return true;
          }
          return false;
        })
        .sort((a, b) => {
          return a.order > b.order ? 1 : -1;
        });

      setFilteredTimelines(results);
    } else {
      setFilteredTimelines(items);
    }
  }, [searchVal]);

  useEffect(() => {
    setFilteredTimelines(items);
  }, [items]);

  const handleKeyClose = (ev) => {
    if (ev.key && ev.key.toLowerCase() === "escape") {
      closeModal();
    }
  };

  useEventListener("keyup", handleKeyClose);

  const tooltipID = "chronos-timeline-manager-tooltip";
  ReactTooltip.rebuild();
  return (
    <div className="chronos-timelines-list-form chronos-timeline-manager chronos-list-form">
      {/* <p>
        Here, you can manage the timelines that are linked to this Chronicle.
        You can add, remove or re-order them. The maximum number of Timelines
        that can be displayed is{' '}
        <span className="chronos-code">
          {process.env.CHRONOS_TIMELINES_DISPLAY}
        </span>
        . By default, 1-2 may be visible (depending on your screen size), but
        the Timelines shown in the bottom track of the Chronicle display can be
        scrolled. It is advised to use fewer timelines if possible, because
        multiples can slow down the Chronicle's display time.
      </p> */}
      <div className="chronos-list-header">
        <div className="chronos-list-search">
          <input
            type="text"
            value={searchVal}
            onChange={handleSearchChange}
            placeholder="Search Timelines"
            className="chronos-search-input chronos-input form-control chronos-component-search"
          />
          <Icon icon="fas fa-search fa-fw" />
        </div>
        <div
          className="chronos-list-options"
          data-for={tooltipID}
          data-tip={
            timelinesAvailable <= 0
              ? `You may have only ${process.env.CHRONOS_TIMELINES_DISPLAY} timelines active!`
              : ""
          }
        >
          <Button
            // disabled={timelinesAvailable}
            color="success"
            type="button"
            onClick={handleNewTimeline}
            style={{ zIndex: 1 }}
          >
            <Icon icon="fas fa-plus fa-fw" />
            New Timeline
          </Button>
        </div>
      </div>

      <ul className="chronos-timeline-list chronos-list">
        {filteredTimelines
          .sort((a, b) => {
            return a.order > b.order ? 1 : -1;
          })
          .map((timeline, index) => {
            return (
              <TimelineListItem
                timeline={timeline}
                key={timeline._id}
                onToggle={handleTimelineToggle}
                onDelete={handleDeleteTimeline}
                onEdit={handleEditTimeline}
              />
            );
          })}
        {filteredTimelines.length === 0 && searchVal !== "" && <NoResults />}
      </ul>
      <div className="form-controls">
        {/* &nbsp;
        <Button color="primary" onClick={handleFormClose}>
          <Icon icon="far fa-times fa-fw" />
          Close
        </Button> */}
      </div>
      <ReactTooltip id={tooltipID} effect="solid" />
    </div>
  );
}

function NoResults() {
  return (
    <li className="chronos-list-item chronos-timelines-list-item chronos-no-results-item">
      <span className="chronos-no-results-title">
        <Icon icon="fal fa-exclamaton-circle fa-fw" />
        &nbsp;No Results
      </span>
    </li>
  );
}
